"use client";

import { Archivo } from "next/font/google";
import { useEffect, useRef, useState } from "react";

const archivoThinItalic2 = Archivo({
  subsets: ["latin"],
  weight: "300",
  style: "italic",
});

const archivoBlack = Archivo({
  subsets: ["latin"],
  weight: "900",
});

const archivoThinItalic = Archivo({
  subsets: ["latin"],
  weight: "300",
  style: "italic",
});

export default function CatchphraseSection() {
  const sectionRef = useRef<HTMLElement | null>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const sectionElement = sectionRef.current;
    if (!sectionElement) {
      return;
    }

    const checkCentered = () => {
      const rect = sectionElement.getBoundingClientRect();
      const viewportCenter = window.innerHeight / 2;

      if (rect.top <= viewportCenter && rect.bottom >= viewportCenter) {
        setIsVisible(true);
      }
    };

    checkCentered();

    window.addEventListener("scroll", checkCentered, { passive: true });
    window.addEventListener("resize", checkCentered);

    return () => {
      window.removeEventListener("scroll", checkCentered);
      window.removeEventListener("resize", checkCentered);
    };
  }, []);

  return (
    <section ref={sectionRef} className="py-32 md:py-40 bg-[#0D0D0D]">
      <div className="max-w-6xl mx-auto px-6 text-center">
        <div className="w-full">
          <h1 className="text-3xl md:text-5xl lg:text-7xl font-bold leading-[1.00] tracking-tight text-[#F0F0F0]">
            <span className={archivoThinItalic2.className}>AMPLIFYING</span>
            <br />
            <span className={archivoBlack.className}>VOICES</span>
          </h1>
          <p className={`${archivoThinItalic.className} text-3xl md:text-3xl text-muted w-full max-w-6xl mx-auto leading-relaxed overflow-hidden transition-all duration-500 ${
            isVisible
              ? "opacity-100 max-h-24 translate-y-0 mt-3"
              : "opacity-0 max-h-0 -translate-y-2"
          }`}>
            We connect elite brands with culture defining creators
          </p>
        </div>
      </div>
    </section>
  );
}
